import React from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export function PageContainer({ children, className = "" }) {
  return (
    <div className={`w-full max-w-md mx-auto sm:max-w-xl md:max-w-4xl lg:max-w-6xl px-4 md:px-6 ${className}`}>
      {children}
    </div>
  );
}

export function PageHeader({ eyebrow, title, subtitle }) {
  return (
    <div className="mb-8" data-testid="page-header">
      {eyebrow && (
        <span className="inline-block text-xs font-bold uppercase tracking-widest text-brand bg-brand-light px-3 py-1 rounded-full mb-3">
          {eyebrow}
        </span>
      )}
      <h1 className="font-heading text-3xl sm:text-4xl font-black tracking-tight text-slate-900">{title}</h1>
      {subtitle && <p className="text-slate-600 mt-2 max-w-2xl leading-relaxed">{subtitle}</p>}
    </div>
  );
}
